/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from "react-redux";
import Styled from 'styled-components'
import { message, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import Compare from './compare';
import { getCollectId } from './helper';
import { actions } from "../../../store/reducers/admin";
import DynamicForm from '../../../components/DynamicFormNew/index';
import { actions as sclActions } from '../../../store/reducers/scl';
import { actions as lirActions } from '../../../store/reducers/lir';
import { actions as admActions } from '../../../store/reducers/adm';
import { actions as stkActions } from '../../../store/reducers/stakeholder';
import { ModalHeader } from "datastake-daf/dist/components";

const Styles = Styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	.form {
		max-width: 630px;
		flex-grow: 1;
		padding: var(--size);
		overflow-y: auto;
		height: 100%;
	}
	.forms {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		overflow-y: auto;
		width: 350px;
		max-height: 100%;
		height: 100%;
		background: #fafafa;
		border-right: 1px solid rgba(0,0,0,0.1);
		button {
			display: flex;
			flex-direction: row;
			justify-content: start;
			align-items: center;
			text-align: start;
			height: fit-content;
			padding: var(--size);
			white-space: pre-wrap;
			> span[role="img"]:nth-of-type(1) {
				font-size: var(--size-lg);
				color: rgba(0, 0, 0, 0.55);
				margin-right: var(--size);
			}
			> div {
				width: 100%;
				align-items: center;
				span {
					font-size: 14px;
				}
				> div {
					span:nth-of-type(1) {
						font-weight: 500;
						color: rgba(0, 0, 0, 0.65);
					}
					span:nth-of-type(2) {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.55);
					}
				}
			}
		}
		button.active {
			background: rgba(161, 194, 250, 0.16);
			border: none;
			> span[role="img"]:nth-of-type(1) {
				color: var(--color-primary-70);
			}
			> div {
				> div {
					span:nth-of-type(1) {
						color: var(--color-primary-70);
					}
				}
			}
		}
	}
`;

function Update({
  isCreate = false,
  stakeholder: { data: stakeholderData },
  scl: { data: locationsData, retrived },
  lir: { data: lirData, retrived: lirRetrived },
  adm: { data: admData, retrived: admRetrived },
  module,
  view,
  entity,
  entityData = {},
  allData = [],
  onUpdate = () => { },
  stakeholderDataGet,
  SCLDataGet,
  lirDataGet,
  updateGlobal,
  admDataGet,
  admLevels = {},
}) {
  const [form, setForm] = useState(null);
  const [data, setData] = useState(null);
  const [newData, setNewData] = useState(null);
  const [payloadData, setPayloadData] = useState(null);
  const [oldData, setOldData] = useState(null);
  const [compareVisible, setCompareVisible] = useState(false);

  const formFn = {
    stakeholders: stakeholderDataGet,
    locations: SCLDataGet,
    scl: SCLDataGet,
    scp: stakeholderDataGet,
    lir: lirDataGet,
    administrativeLevel1: admDataGet,
    administrativeLevel2: admDataGet,
    administrativeLevel3: admDataGet,
    administrativeLevel4: admDataGet,
    administrativeLevel5: admDataGet,
    administrativeLevel6: admDataGet,
    administrativeLevel7: admDataGet,
    administrativeLevel8: admDataGet,
    administrativeLevel9: admDataGet,
    administrativeLevel10: admDataGet,
  };
  const namespace = {
    stakeholders: 'Stakeholder',
    locations: 'SCL',
    scl: 'SCL',
    scp: 'Stakeholder',
    lir: 'Lir',
    administrativeLevel1: 'ADM',
    administrativeLevel2: 'ADM',
    administrativeLevel3: 'ADM',
    administrativeLevel4: 'ADM',
    administrativeLevel5: 'ADM',
    administrativeLevel6: 'ADM',
    administrativeLevel7: 'ADM',
    administrativeLevel8: 'ADM',
    administrativeLevel9: 'ADM',
    administrativeLevel10: 'ADM',
  };

  useEffect(() => {
    formFn[entity]({ namespace: namespace[entity], module, view: admLevels[entity] || view });
  }, [entity]);

  useEffect(() => {
    if (stakeholderData[`${module}-${view}`]) {
      setForm(stakeholderData[`${module}-${view}`].form || {});
      const { countryName, categoryName, subCategoryName, ...eData } = entityData;
      setData(eData);
    }
  }, [stakeholderData]);

  useEffect(() => {
    if (locationsData[`${module}-${view}`]) {
      setForm(locationsData[`${module}-${view}`].form || {});
      const { countryName, categoryName, administrativeLevel1Name, administrativeLevel2Name, ...eData } = entityData;
      setData(eData);
    }
  }, [locationsData, retrived]);

  useEffect(() => {
    if (lirData[`${module}-${view}`]) {
      setForm(lirData[`${module}-${view}`].form || {});
      const { countryName, categoryName, subCategoryName, ...eData } = entityData;
      setData(eData);
    }
  }, [lirData, lirRetrived]);

  useEffect(() => {
    if (admData[`${admLevels[entity] || view}`]) {
      const admForm = admData[`${admLevels[entity] || view}`].form || {};
      admForm.location = Object.keys(admForm.location).reduce((item, key) => {
        if (key === 'name') {
          admForm.location[key].inputType = entityData && entityData.id ? 'text' : 'multiselect';
        }
        item[key] = admForm.location[key];
        return item;
      }, {});
      setForm(admData[`${admLevels[entity] || view}`].form || {});
      const { countryName, levelName, ...eData } = entityData;
      setData(eData);
    }
  }, [admData, admRetrived, admLevels[entity]]);

  const getFormConfig = () => {
    const newForm = JSON.parse(JSON.stringify(form));
    if (data.id && namespace[entity] === 'ADM' && newForm.location && newForm.location.name && newForm.location.name.inputType) {
      newForm.location.name.inputType = entityData && entityData.id ? 'text' : 'multiselect';
    }
    return newForm;
  }

  return <Styles>
    {form && data ? <DynamicForm
      form={getFormConfig()}
      data={data}
      module={module}
      showSaveAndNext={false}
      submit={(payload, setSelectedFormNext) => {
        const newCollectId = payload.id || namespace[entity] !== 'ADM' ? getCollectId(entity, payload) : '';
        const dataExists = allData.find(d => d.collectId === newCollectId);
        const _isCreate = isCreate;
        if (!!dataExists) {
          setNewData(dataExists);
          setPayloadData(payload);
          setOldData(data);
          setCompareVisible(true);
        } else {
          updateGlobal(entity, Object.assign(payload, {
            collectId: newCollectId,
          }), () => {
            message.success(!_isCreate ? 'Entity updated' : 'Entity created');
            onUpdate();
          }, (err) => {
            setSelectedFormNext()
            message.error(err.data && err.data.message ? err.data.message : (err.message || 'Something went wrong through update'))
          });
        }
      }}
    ></DynamicForm> : null}
    <Modal
      title={(
        <ModalHeader
          title="Data conflict"
        />
      )}
      okText={!isCreate ? "Merge" : "Ok"}
      onOk={() => {
        if (!isCreate) {
          updateGlobal(entity, Object.assign(payloadData, {
            collectId: getCollectId(entity, payloadData)
          }), () => {
            message.success(isCreate ? 'Entity updated' : 'Entity created');
            setCompareVisible(false);
            onUpdate();
          }, (err) => {
            setCompareVisible(false);
            message.error(err.data && err.data.message ? err.data.message : (err.message || 'Something went wrong through update'))
          });
        } else {
          setCompareVisible(false);
          onUpdate();
        }
      }}
      onCancel={() => setCompareVisible(false)}
      open={compareVisible}>
      <Compare
        entity={entity}
        isCreate={isCreate}
        form={form}
        oldData={oldData}
        newData={newData} />
    </Modal>
  </Styles>
}

const mstp = ({ admin, stakeholder, scl, lir, adm }) => ({ admin, stakeholder, scl, lir, adm });

export default connect(mstp, { ...actions, ...stkActions, ...sclActions, ...lirActions, ...admActions })(Update);
